/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type VideoStatus = (typeof VideoStatus)[keyof typeof VideoStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VideoStatus = {
  UPLOADING: 'UPLOADING',
  PROCESSING: 'PROCESSING',
  AVAILABLE: 'AVAILABLE',
  ERROR: 'ERROR',
} as const
